<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="carrera-plan" titulo="Carreras Planes / Coordinación académica" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>


<div class="contenedor columns " style="height:100%; ">
  <div class="column is-1 is-hidden-mobile menu-izquierda">

    <!-- Menu izquierda del modulo enviroment" -->
    <app-sistema-menu-aside></app-sistema-menu-aside>
  </div>
  <div class="column" style="padding:0px;">
    <div style="background: #FFF; border-radius: 1em; ">

      <!-- formulario -->
      <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
        <section class="hero is-primary">
          <div class="hero-body">

            <!-- Opciones  -->
            <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
          </div>
        </section>

        <section class="section" style="overflow-y:auto; overflow-x:hidden; height: 85.8vh;">
          <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
          <a id="recargar" (click)="!ctrl.cargando ? ctrl.cargarDatos() : ''"></a>
          <a id="catalogos" (click)="ctrl.cargarCatalogo('modalidades', 'modalidad');"></a>

          <div class="tabs is-boxed">
            <ul >
              <li  [ngClass]="{ 'is-active' : tab2 == 0}">
                <a (click)="tab2=0">
                  <span class="icon">
                    <i class="fa fa-home"></i>
                  </span>
                  <span class="is-hidden-touch">General</span>
                </a>
              </li>
              <li [ngClass]="{ 'is-active' : tab2 == 1}">
                <a (click)="tab2=1">
                  <span class="icon">
                    <i class="icon-exam"></i>
                  </span>
                  <span class="is-hidden-touch">Opciones de calificación...</span>
                </a>
              </li>
            </ul>
          </div>

          <!-- GENERAL -->
          <div [ngClass]="{ 'is-hidden': tab2 != 0}">
            <div class="columns">
              <div class="column is-4">
                <div class="field is-fullwidth" formGroupName="planes_estudios" >
                  <label class="label">Plan de estudios:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="Nombre" formControlName="nombre" readonly>
                  </p>
                </div>
              </div>
              <div class="column is-5">
                <div class="field is-fullwidth" formGroupName="carreras" >
                  <label class="label">Carrera:</label>
                  <p class="control has-icons-left has-icons-right">
                    <input class="input" type="text" placeholder="Nombre" formControlName="nombre" readonly>
                  </p>
                </div>
              </div>

              <div class="column is-2">
                <div class="field is-fullwidth" >
                  <label class="label">Esta activo:</label>
                  <div class="control has-icons-left has-icons-right">
                    <div class="b-checkbox is-info">
                      <input id="activo" class="styled" [checked]="ctrl.dato.get('activo').value == '1' ? true : false"
                        (change)="ctrl.dato.get('activo').patchValue(ctrl.dato.get('activo').value == '1' ? '0' : '1')" type="checkbox">
                      <label for="activo">
                        Si
                      </label>    
                    </div>
                  </div>
                </div>
              </div>

              <div class="column is-1">
                <div class="field is-narrow">
                    <p class="control">
                        <button class="button is-primary" (click)="generarPDF();" >
                          <span class="icon fa-2x" style="color: white;">
                              <i class="icon-print"></i>
                          </span>
                          <span style="color: white;">Imprimir</span>
                        </button>
                    </p>
                </div>
              </div>




            </div>

            <div class="columns">
              <div class="column is-4">
                <label class="label">RVOE:</label>
                <p class="control has-icons-left has-icons-right">
                  <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('rvoe').hasError('required')}"
                    placeholder="RVOE" formControlName="rvoe">
                  <span class="icon is-small is-right" *ngIf="ctrl.dato.get('rvoe').hasError('required')">
                    <i class="fa fa-warning"></i>
                  </span>
                  <span class="help is-danger" *ngIf="ctrl.dato.get('rvoe').hasError('required')">Este campo es
                    requerido.</span>
                </p>
              </div>

              <div class="column is-8">
                <label class="label">Vigente desde:</label>
                <p class="control has-icons-left has-icons-right">
                  <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('vigente_desde').hasError('required')}"
                    placeholder="Vigencia" formControlName="vigente_desde">
                  <span class="icon is-small is-right" *ngIf="ctrl.dato.get('vigente_desde').hasError('required')">
                    <i class="fa fa-warning"></i>
                  </span>
                  <span class="help is-danger" *ngIf="ctrl.dato.get('vigente_desde').hasError('required')">Este campo es
                    requerido.</span>
                </p>
              </div>
            </div>

            <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px;">
              <button type="button" class="button is-default" (click)="agregar_categoria_materia(); tab = ctrl.dato.controls.categorias_materias.controls.length - 1">
                <i class="fa fa-plus"></i> Agregar Categoría
              </button>
            </div>
            <br>
            <div class="tabs is-boxed">
              <ul *ngIf="ctrl.dato.get('categorias_materias').length > 0">
                <li *ngFor="let item of ctrl.dato.controls.categorias_materias.controls; let i=index" [ngClass]="{ 'is-active' : tab == i}">
                  <a (click)="tab=i">
                    <span class="icon">
                      <i class="fa fa-file"></i>
                    </span>
                    <span class="is-hidden-touch">CATEGORÍA # {{ i + 1 }} &nbsp;
                      <button style="margin-top: -5px; float:right" type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.categorias_materias, i)">
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </span>
                  </a>
                </li>
              </ul>
            </div>
            <div formArrayName="categorias_materias">
              <div *ngFor="let categoria of ctrl.dato.controls.categorias_materias.controls; let i=index" [ngClass]="{ 'is-hidden': tab != i}">
                <div [formGroupName]="i">
                  <div class="field">
                    <label class="label">Nombre:</label>
                    <p class="control has-icons-left has-icons-right">
                      <input class="input" type="text" placeholder="Nombre" formControlName="nombre">

                      <span class="help is-danger" *ngIf="!categoria.controls.nombre.valid">Este campo es requerido.</span>
                    </p>
                  </div>
                  <div formArrayName="materias">
                    <table class="table is-striped  is-fullwidth" *ngIf="categoria.get('materias').length > 0">
                      <thead>
                        <tr>
                          <!-- <th hide-sm>ID</th> -->
                          <th style="width:10%;">Orden</th>
                          <th style="width:10%;">ID_ASIGNATURA</th>
                          <th style="width:30%;">Nombre de materia </th>
                          <th style="width:10%;">Clave</th>
                          <th style="width:10%;">Nivel</th>
                          <th style="width:10%;">HD</th>
                          <th style="width:10%;">HI</th>
                          <!-- <th style="width:20%;">Práctica?</th> -->
                          <!-- <th style="width:10%;">% Práctica</th> -->
                          <th style="width:10%;">Créditos</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let materia of categoria.controls.materias.controls; let m=index" [formGroupName]="m">
                          <!-- <td>{{ m + 1 }}</td> -->
                          <td>
                            <p class="control has-icons-left has-icons-right">
                              <input class="input" type="number" placeholder="Orden" formControlName="orden">
                              <span class="help is-danger" *ngIf="!categoria.controls.materias.controls[m].controls.orden.valid">Este
                                campo es requerido.</span>
                            </p>
                          </td>

                          <td>
                            <p class="control has-icons-left has-icons-right">
                              <input class="input" type="number" placeholder="ID_ASIGNATURA" formControlName="id_asignatura">
                              <span class="help is-danger" *ngIf="!categoria.controls.materias.controls[m].controls.id_asignatura.valid">Este
                                campo es requerido.</span>
                            </p>
                          </td>

                          <td>
                            <p class="control has-icons-left has-icons-right">
                              <input class="input" type="text" placeholder="Nombre" formControlName="nombre">
                              <span class="help is-danger" *ngIf="!categoria.controls.materias.controls[m].controls.nombre.valid">Este
                                campo es requerido.</span>
                            </p>
                          </td>
                          <td>
                            <p class="control has-icons-left has-icons-right">
                              <input class="input" type="text" placeholder="Clave" formControlName="clave">
                              <span class="help is-danger" *ngIf="!categoria.controls.materias.controls[m].controls.clave.valid">Este
                                campo es requerido.</span>
                            </p>
                          </td>
                          <td>
                            <p class="control has-icons-left has-icons-right">
                              <input class="input" type="number" min="1" max="9" placeholder="Nivel" formControlName="nivel">
                              <span class="help is-danger" *ngIf="!categoria.controls.materias.controls[m].controls.nivel.valid">Este
                                campo es requerido.</span>
                            </p>
                          </td>
                          <td>
                            <p class="control has-icons-left has-icons-right">
                              <input class="input" type="number" min="1" placeholder="HD" formControlName="hd">
                              <span class="help is-danger" *ngIf="!categoria.controls.materias.controls[m].controls.hd.valid">Este
                                campo es requerido.</span>
                            </p>
                          </td>
                          <td>
                            <p class="control has-icons-left has-icons-right">
                              <input class="input" type="number" min="1" max="100" placeholder="HI" formControlName="hi">
                              <span class="help is-danger" *ngIf="!categoria.controls.materias.controls[m].controls.hi.valid">Este
                                campo es requerido.</span>
                            </p>
                          </td>

                          <td>
                            <p class="control has-icons-left has-icons-right">
                              <input class="input" type="number" min="1" placeholder="Créditos" formControlName="creditos">
                              <span class="help is-danger" *ngIf="!categoria.controls.materias.controls[m].controls.creditos.valid">Este
                                campo es requerido.</span>
                            </p>
                          </td>
                          <td align="right">
                            <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(categoria.controls.materias, m)">
                              <i class="fa fa-trash-o"></i>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div style="background: rgba(220, 187, 42, 0.609); width:100%; padding: 10px; margin-top: 20px;">
                    <button type="button" class="button is-default" (click)="agregar_materia(i)">
                      <i class="fa fa-plus"></i> Agregar Materia
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- OPCIONES -->
          <div [ngClass]="{ 'is-hidden': tab2 != 1}">
            <div class="field is-fullwidth">
              <label class="label">Minimo aprobatorio:</label>
              <p class="control has-icons-left has-icons-right">
                <input class="input" type="number" formControlName="minimo_aprobatorio">
              </p>
            </div>

            <div style="background: rgba(127, 220, 42, 0.62); width:100%; padding: 10px;">
              <!-- <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.opciones_calificacion, opciones_calificacion);">
                <i class="fa fa-plus"></i> Agregar Opción
              </button> -->

              <button type="button" class="button is-default" (click)="agregar_opcion()">
                <i class="fa fa-plus"></i> Agregar Opción
              </button>
            </div>

            <div formArrayName="opciones_calificacion">
              <table class="table is-striped  is-fullwidth" >
                <thead>
                  <tr>
                    <!-- <th hide-sm>ID</th> -->
                    <th style="width:10%;">#</th>
                    <th style="width:30%;">Modalidad </th>
                    <th style="width:30%;">Nombre </th>
                    <th style="width:10%;">Tipo</th>
                    <th style="width:10%;">Orden</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let opcion of ctrl.dato.controls.opciones_calificacion.controls; let i=index" [formGroupName]="i">
                    <td>{{ i + 1 }}</td>
                    <td>
                      <ng-select2 [disabled]="ctrl.modalidades ? ctrl.modalidades.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="opcion.value.modalidades_id" (valueChanged)="ctrl.seleccionarValorSelect2($event, opcion.controls.modalidades_id);"
                        [data]="ctrl.modalidades"></ng-select2>
                    </td>
                    <td>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="Nombre" formControlName="nombre">
                        <span class="help is-danger" *ngIf="!opcion.controls.nombre.valid">Este campo es requerido.</span>
                      </p>
                    </td>
                    <td>
                      <ng-select2 [disabled]="tipos_opciones ? tipos_opciones.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="opcion.value.tipo" (valueChanged)="ctrl.seleccionarValorSelect2($event, opcion.controls.tipo);"
                        [data]="tipos_opciones"></ng-select2>
                    </td>
                    <td>
                      <p class="control has-icons-left has-icons-right">
                        <input class="input" type="text" placeholder="Orden" formControlName="orden">
                        <span class="help is-danger" *ngIf="!opcion.controls.orden.valid">Este campo es requerido.</span>
                      </p>
                    </td>

                    <td align="right">
                      <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.opciones_calificacion, i)">
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>

        </section>

      </form>
    </div>
  </div>
</div>
